import { render, staticRenderFns } from "./AddNewCard.vue?vue&type=template&id=11b7aefc&scoped=true&"
import script from "./AddNewCard.vue?vue&type=script&lang=js&"
export * from "./AddNewCard.vue?vue&type=script&lang=js&"
import style0 from "./AddNewCard.vue?vue&type=style&index=0&id=11b7aefc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b7aefc",
  null
  
)

export default component.exports